import { GenericLazyString } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';
import { MapPinIcon } from './MapPinIcon';

import './AboutPOICard.scss';

export interface AboutData {
    title: string | GenericLazyString;
    content: string | GenericLazyString;
    address: string;
}

interface AboutPOICardProps {
    aboutData: AboutData;
}

/**
 * About Card which shows Title, Content/Description, Address for a Point of Interest(POI)
 */
export const AboutPOICard: React.VFC<AboutPOICardProps> = ({ aboutData }) => {
    const { title, content, address } = aboutData;

    return (
        <div className="poi-about eds-l-pad-all-8 eds-l-mar-left-18 eds-l-mar-bot-20">
            <Typography
                align="left"
                as="h2"
                color="neutral-1000"
                variant="heading-sm"
                className="eds-l-pad-bot-6"
            >
                {title}
            </Typography>
            <Typography
                align="left"
                as="p"
                color="neutral-800"
                variant="body-md"
                className="poi-about__content eds-text-color--grey-800 eds-l-pad-bot-5"
            >
                {content}
                <br />
                <br />
            </Typography>
            <div className="eds-align--center-vertical">
                <div className="poi-about__address-icon">
                    <MapPinIcon />
                </div>
                <p className="poi-about__address eds-g-group eds-text-bm eds-text-weight--heavy eds-text--left eds-l-mar-left-2">
                    {address}
                </p>
            </div>
        </div>
    );
};
